import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import QueryMailExternal from 'graphql/queries/QueryMailExternal'

const FetchEmailExternal = {
	
	fetch: ( guid, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'email_external', QueryMailExternal, {
			//instant: true,
			variables: { guid },
			resultPath: [ 'email_external' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	}
}

export default FetchEmailExternal
